import styled from 'styled-components';

export const StyledForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 12px;
`;

StyledForm.displayName = 'StyledForm';
